import * as types from "./constant";
import apis from "@/apis";
import { loadFromLocal, saveToLocal } from "@/utils/localStorage";
export default {
    state: {
        test: false
    },
    actions: {
        updateTest({ commit, state }, params) {
            commit(types.TEST, params)
        }
    },
    mutations: {
        [types.TEST](state, payload) {
            state.test = payload
        }
    },
    getters: {
        test(state) {
            return state.test
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/listReload/index.js